import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/store';
import App from './App';
import { initDevToolsGuard } from './utils/disableDevTools';

// Activate DevTools guard on production (patientapp.shalamarhospital.org.pk / apis.sihs.org.pk) — before React mounts
initDevToolsGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
